import { CheckoutStates } from 'components/DSO/DSOOrderCheckout/DSOOrderCheckout.types';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCheckoutService } from 'services';

export const useDsoSaveOrderPaymentMethod = (
  setOrderStep: Dispatch<SetStateAction<CheckoutStates>>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    (paymentMethodId: string) => {
      return dsoCheckoutService.saveOrderPaymentMethod(paymentMethodId);
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
        setOrderStep('confirm');
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
